<app-hvb-header></app-hvb-header>
<hr class="mb-0">
<div class="contact-page">
  <div class="title">{{'downloadArea.title' | translate}}</div>
  <ul>
    <li>
      <a href="assets/documents/2_Zulassungsantrag_Mitgliedschaft_Hanseatische_Versicherungsboerse_e.V._-_Stand_22.06.2023.pdf"
        target=”_blank”>{{'downloadArea.membershipApplication' |translate}}</a>
    </li>
    <li>
      <a href="assets/documents/Satzung_der_Hanseatischen_Versicherungsborse_-_Stand_14.02.2023.pdf"
        target=”_blank”>{{'downloadArea.bylaws' |translate}}</a>
    </li>
    <li>
      <a href="assets/documents/Antrag_auf_Zulassung_zum_Boersenbesuch_HVB_eV-Stand_2025.pdf"
        target=”_blank”>{{'downloadArea.admissionApplication' |translate}}</a>
    </li>
    <li>
      <a href="assets/documents/dHVB_Borsenordnung_2023.pdf"
        target=”_blank”>{{'downloadArea.exchangeRules' |translate}}</a>
    </li>
  </ul>
</div>
<hvb-footer></hvb-footer>
